import jwt_decode from "jwt-decode"

export function DecodeJwt<T>(jwt: string): T {
  return jwt_decode<T>(jwt)
}
